/* --------------------------------------------------
Import Modules
-------------------------------------------------- */
import { each } from 'meteora';
/* --------------------------------------------------
Image Grid - Colours
-------------------------------------------------- */

each('.js-image-grid--colours', function (colours) {
  // Find all the colours
  var items = colours.querySelectorAll('.js-image-grid--colours-item'); // Set a custom delay in milliseconds

  var delay = 200; // Loop through each item and set the transition delay to the index

  for (var i = 0; i < items.length; i++) {
    items[i].style.transitionDelay = "".concat(i * delay, "ms");
  }
});